import WaitingRoomTable from './WaitingRoomTable.component';

export default WaitingRoomTable;
